import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startReport1022Status: 'idle',
    startReport1022Error: undefined as any,
    loadUserParamsReport1022Status: 'idle',
    loadUserParamsReport1022Error: undefined as any,

    report1022List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startReport1022 = createAsyncThunk('report1022Slice/startReport1022', async ({ report1022 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartReport1022/`,
        prepareData(report1022),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startReport1022Status } = getState().report1022Slice
        return startReport1022Status !== 'pending'
    }
})

export const loadUserParamsReport1022 = createAsyncThunk('report1022Slice/loadUserParamsReport1022', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsReport1022/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsReport1022Status } = getState().report1022Slice
        return loadUserParamsReport1022Status !== 'pending'
    }
})

const Report1022Slice = createSlice({
    name: 'report1022Slice',
    initialState,
    reducers: {
        resetstartReport1022: (state) => {
            state.job = undefined
            state.startReport1022Error = undefined
        },
        resetstartReport1022Error: (state) => {
            state.startReport1022Error = undefined
        },
        resetloadUserParamsReport1022: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsReport1022Error = undefined
        },
        resetloadUserParamsReport1022Error: (state) => {
            state.loadUserParamsReport1022Error = undefined
        },
        removeFromReport1022ListById: (state, action) => {
            state.report1022List = state.report1022List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromReport1022ListByIds: (state, action) => {
            state.report1022List = state.report1022List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.report1022List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startReport1022Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.report1022List = []
            state.startReport1022Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startReport1022.pending, (state) => {
            state.startReport1022Status = 'pending'
            state.startReport1022Error = undefined
        })
        builder.addCase(startReport1022.fulfilled, (state, action) => {
            state.startReport1022Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startReport1022.rejected, (state, action) => {
            state.startReport1022Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startReport1022Error = action.error.message
            } else {
                state.startReport1022Error = action.payload
            }
        })

        builder.addCase(loadUserParamsReport1022.pending, (state) => {
            state.loadUserParamsReport1022Status = 'pending'
            state.loadUserParamsReport1022Error = undefined
        })
        builder.addCase(loadUserParamsReport1022.fulfilled, (state, action) => {
            state.loadUserParamsReport1022Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsReport1022.rejected, (state, action) => {
            state.loadUserParamsReport1022Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsReport1022Error = action.error.message
            } else {
                state.loadUserParamsReport1022Error = action.payload
            }
        })

    }
})

export const {
    resetstartReport1022,
    resetstartReport1022Error,
    resetloadUserParamsReport1022,
    resetloadUserParamsReport1022Error,
    removeFromReport1022ListById,
    removeFromReport1022ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Report1022Slice.actions
export default Report1022Slice.reducer
